import Vue from "vue";
import VueRouter from "vue-router";
import VueMeta from "vue-meta";

import store from "@/state/store";
import routes from "./routes";

Vue.use(VueRouter);
Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: "page",
});

const router = new VueRouter({
  routes,
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: "history",
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

// Before each route evaluates...
router.beforeEach((routeTo, routeFrom, next) => {
  if (
    routeTo.name == "Dashboard" &&
    routeTo.params.user_id !== undefined &&
    routeTo.params.entity_id !== undefined &&
    routeTo.params.server_id !== undefined &&
    routeTo.params.enc_pwd !== undefined &&
    routeTo.params.enc_email !== undefined && 
    routeTo.params.code !== undefined
  ) {
    store.commit("user/setEncPwd", routeTo.params.enc_pwd);
    store.commit("user/setEncEmail", routeTo.params.enc_email);
    store.commit("user/setCode", routeTo.params.code);
    store.commit("entities/setPendingInvitation", routeTo.params);
    localStorage.setItem("userOtpRequired", 0);
    localStorage.setItem("userIsVerified", 0);

  }
  if (routeTo.name == "QuickPass" || routeTo.name == "QuickPass2") {
    store.commit("quickpass/setQrUrl", null);
    store.commit("quickpass/setPdfUrl", null);
  }
  if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
    // Check if auth is required on this route
    // (including nested routes).
    const authRequired = routeTo.matched.some(
      (route) => route.meta.authRequired
    );

    // If auth isn't required for the route, just continue.
    if (!authRequired) return next();

    // If auth is required and the user is logged in...
    if (store.getters["auth/loggedIn"]) {
      // Validate the local user token...
      return store.dispatch("auth/validate").then((validUser) => {
        // Then continue if the token still represents a valid user,
        // otherwise redirect to login.
        validUser ? next() : redirectToLogin();
      });
    }

    // If auth is required and the user is NOT currently logged in,
    // redirect to login.
    redirectToLogin();

    // eslint-disable-next-line no-unused-vars
    // eslint-disable-next-line no-inner-declarations
    function redirectToLogin() {
      // Pass the original route to the login component
      next({ name: "login", query: { redirectFrom: routeTo.fullPath } });
    }
  } else {
    const publicPages = [
      "/login",
      "/register",
      "/forgot-password",
      "/quick-pass",
      "/register-selector",
      "/register-passport",
      "/forget-password",
      "/success-email",
      "/qp",
      "/success-sms",
      "/success-register",
      "/link-expired",
    ];
    let authpage = !publicPages.includes(routeTo.path);
    if (
      routeTo.path.startsWith("/reset-password") ||
      routeTo.path.startsWith("/login")
    ) {
      authpage = false;
    }
    const loggeduser = localStorage.getItem("user");
    const userOtpRequired = parseInt(localStorage.getItem('userOtpRequired'));
    const userIsVerified = parseInt(localStorage.getItem('userIsVerified'));

    // console.log('userOtpRequired', userOtpRequired);
    // console.log('userIsVerified', userIsVerified);
    
    if (authpage && !loggeduser && !userOtpRequired) {
      // if (routeTo.name == "Dashboard") {
      //   return next("/verify-otp-code");
      // }else{
        // console.log('aaa');
        setTimeout(() => {
          return next("/login");
        }, 500);
      // }
    } else if (loggeduser && routeTo.name === "login") {
      // console.log('bbb');
      if (loggeduser && userOtpRequired && !userIsVerified) {
        // console.log('ccc');
        return next("/verify-otp-code");
      }else{
        next({ name: "Dashboard", query: routeTo.query });  
      }
    } else if (loggeduser && routeTo.name === "confirmVericationCode" && userIsVerified) {
        next({ name: "Dashboard", query: routeTo.query });  
    }else if (loggeduser && routeTo.name === "confirmVericationCode" && !userIsVerified) {
      next();  
    }else if (authpage && loggeduser  && !userOtpRequired) {
      // console.log('ddd');
      let user_image = JSON.parse(loggeduser)?.data?.user?.image;
      if (user_image) {
        return next();
      } else if (
        routeTo.name !== "uploadImage" &&
        (routeFrom.query?.jf_id || routeTo.query?.jf_id)
      ) {
        return next("/upload-image");
      }
    }
    next();
  }
});

router.beforeResolve(async (routeTo, routeFrom, next) => {
  // Create a `beforeResolve` hook, which fires whenever
  // `beforeRouteEnter` and `beforeRouteUpdate` would. This
  // allows us to ensure data is fetched even when params change,
  // but the resolved route does not. We put it in `meta` to
  // indicate that it's a hook we created, rather than part of
  // Vue Router (yet?).
  try {
    // For each matched route...
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            // If the user chose to redirect...
            if (args.length) {
              // If redirecting to the same route we're coming from...
              // Complete the redirect.
              next(...args);
              reject(new Error("Redirected"));
            } else {
              resolve();
            }
          });
        } else {
          // Otherwise, continue resolving the route.
          resolve();
        }
      });
    }
    // If a `beforeResolve` hook chose to redirect, just return.
  } catch (error) {
    return;
  }

  // If we reach this point, continue resolving the route.
  next();
});

export default router;
